import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { url } from "../../Constant";
import { useAuth } from "../../Context/AuthProvider";
import ReactPaginate from "react-paginate";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
const CampaignNumber = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [incomingData, setIncomingData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [apicalled, setApiCalled] = useState(false);

  const { auth } = useAuth();
  useEffect(() => {
    getCampaginNumberDetail(1);
  }, []);
  useEffect(() => {
    if (apicalled === true) {
      getCampaginNumberDetail(1);
    }
  }, [apicalled]);

  const columns = [
    // {
    //   name: "Campaign Name",
    //   selector: (row) => row.campaign_id,
    //   // sortable: true,
    // },
    {
      name: "Master No.",
      selector: (row) => row.caller_id,
    },

    {
      name: "Action",
      selector: (row) => row.callrecording,
      // sortable: true,
      cell: (row) => (
        <div>
          <button
            className={"btn-design alertColor"}
            onClick={() => deleteCampaginNumber(row)}
          >
            Delete
          </button>
          <button
            className={"btn-design  greenColor"}
            onClick={() =>
              navigate(`/campaign_number_edit/${row.caller_id}/${row.s_no}`, {
                replace: true,
              })
            }
            // to={`/campaign_number_edit/${row.caller_id}/${row.s_no}`}
          >
            Edit
          </button>
        </div>
      ),
    },
  ];

  const getCampaginNumberDetail = (page) => {
    axios
      .post(
        url + "tcs-view-campaign-numbers",
        {
          vpbx_id: auth.vpbx_id,
          campaign_id: params.campaign_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            setLoader(false);
            setApiCalled(false);
            if (
              response.data.message === "Data Not Found" &&
              response.data.data.length === 0
            ) {
              setIncomingData([]);
            } else if (response.data.message === "Data Found") {
              setIncomingData(response.data.data.bulk_obd);
              setPageCount(response.data.data.pages);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const deleteCampaginNumber = (row) => {
    axios
      .post(
        url + "tcs-delete-campaign-numbers",
        {
          s_no: row.s_no,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            setLoader(false);
            setApiCalled(false);
            if (
              response.data.message === "Number Delete successfully" &&
              response.data.data.length === 0
            ) {
              toast.success(response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1000,
              });
              setTimeout(() => {
                getCampaginNumberDetail();
              }, 1000);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };

  const filteredIncomming = incomingData.filter((val) => {
    return (
      val.caller_id &&
      val.caller_id.toLowerCase().includes(searchText.toLowerCase())
      //   ||
      // (val.campaign_id &&
      //   val.campaign_id.toLowerCase().includes(searchText.toLowerCase()))
    );
  });

  const handlePageChange = (data) => {
    // console.log(data);
    setLoader(true);
    getCampaginNumberDetail(data.selected + 1);
    setCurrentPage(data.selected + 1);
  };

  return (
    <>
      <div className="dashboardWrp">
        <div className="uk-container uk-container-large">
          <div className="dashboardTop">
            <div uk-grid="" className="uk-grid uk-grid-small">
              <div className="uk-width-2-3">
                <div className="dashboardIntro">
                  <h3>CALL INITIALIZE</h3>
                  {/* {auth.role === "2" && (
                    <p>
                      Use this page to view the call logs or call history,
                      including inbound, outbound, and missed calls.
                    </p>
                  )} */}
                </div>
              </div>
              {/* <div className="uk-width-1-3">
              <div className="dashboardIntro uk-text-right">
                <button>EXPORT DATA</button>
              </div>
            </div> */}

              <div className="uk-width-1-1 ">
                <>
                  <div className="ImcomingCallMain">
                    <div className="uk-grid" uk-grid="">
                      <div className="uk-width-1-2">
                        <div className="uk-text-left">
                          <div className="CustomSearch">
                            <form className="uk-search uk-search-default">
                              <input
                                className="uk-search-input"
                                type="text"
                                placeholder="Search by all field"
                                value={searchText}
                                onChange={handleSearch}
                              />
                            </form>
                          </div>
                        </div>
                      </div>

                      <div className="uk-width-1-2">
                        <div className="uk-text-right">
                          <span>
                            {/* {(auth.role === "2" ||
                              (auth.role === "3" &&
                                checkIndividualPermission(
                                  "campaign",
                                  "read_and_write"
                                ))) && (
                              <div className="uk-inline uk-text-left">
                                <Link
                                  className="exportData-button NewFlow"
                                  to={
                                    auth.role === "3"
                                      ? "/upload-campaign"
                                      : "/upload-campaign"
                                  }
                                >
                                  Create campagin
                                </Link>
                              </div>
                            )} */}
                          </span>
                          {/* <span>
                            <div className="uk-inline uk-text-left">
                              <a
                                className="exportData-button"
                                // onClick={handleOpenFilterModal}
                                to="upload-campaign"
                              >
                                Upload Campaign
                              </a>
                            </div>
                          </span> */}
                        </div>
                      </div>
                    </div>

                    <div>
                      {loader ? (
                        <div uk-spinner="" className="tableloader"></div>
                      ) : (
                        <DataTable
                          columns={columns}
                          data={filteredIncomming}
                          responsive="true"
                          // pagination
                        />
                      )}

                      {pageCount > 0 && (
                        <ReactPaginate
                          previousLabel={"<"}
                          nextLabel={">"}
                          breakLabel={"...."}
                          pageCount={pageCount}
                          onPageChange={handlePageChange}
                          containerClassName={
                            "uk-pagination uk-float-right contatPagination"
                          }
                          activeClassName={"uk-active"}
                          marginPagesDisplayed={3}
                          pageRangeDisplayed={6}
                        />
                      )}
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CampaignNumber;
